<template>
    <md-card class="mb-2">
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', icon]"></font-awesome-icon>
                    </div>
                    <h4 class="title">{{ title }}</h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                    <div class="flex items-center justify-end header-actions">
                        <slot name="header-actions"></slot>
                    </div>
                </div>
            </div>
        </md-card-header>
        <slot name="content"></slot>
    </md-card>
</template>

<script>
export default {
	name: "client-card",
	props: {
		title: String,
		icon: String,
		actions: Boolean
	}
}
</script>

<style scoped lang="scss">
.md-card-header-icon {
	svg {
		color: #FFFFFF;
	}
}
</style>
